(function() {
	angular
		.module('main')
		.controller('LabelsSettingsController', LabelsSettingsController);

	LabelsSettingsController.$inject = [];

	function LabelsSettingsController() {}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/labelsSettingsController.js